(function(window, angular, undefined) {
angular.module('formApp')
.controller('retrieveQuoteCtrl', ['$scope', 'FormService', 'updateHeader', 'formData', '$state', 'stateService', 'errorHandler', 'LoadingInterceptor', 'sessionService', '$location','$rootScope', '$q','$timeout', 'scrollToPoint',
    function($scope, formService, updateHeader, formData, $state, stateService, errorHandler, loadingInterceptor, sessionService, $location, $rootScope, $q,$timeout, scrollToPoint) {
                
    sessionService.stop();
    $scope.straightThroughValidation = false;
    $scope.dobDateMin = moment().subtract(18, 'year').format('YYYY-MM-DD');
    $scope.dobDateMax = moment().subtract(120, 'year').format('YYYY-MM-DD');
    $scope.retrieveQuote = {};

    var refNo = $location.search().RefNo;
    if (refNo) {
        $scope.retrieveQuote.quoteRef = parseInt(refNo, 10);
    }

    var campaign;
    angular.forEach($location.search(), function(value, key) {
        var keyName = key.toLowerCase();
        if (keyName === 'campaign') {
            if (typeof value === 'string' && value !== "") {
                campaign = value.toUpperCase();
            }
        }
    }); 

    var pastCoverStartDate = false;

    $scope.formData = formData;

    if (!sessionStorage.getItem('formStateUri')) {
        var petValue = $location.search().petvalue;
        if (['dog', 'cat', 'rabbit'].indexOf(petValue) !== -1) {
            $scope.formData.pets[0].type = petValue;
            sessionStorage.setItem('petType', petValue);
            updateHeader.petType = petValue;
        }
        
        $scope.breed = $location.search().breed;
        if (['beagle','border-collie','cockapoo','cocker-spaniel','dachshund','german-shepherd','golden-retriever','labradoodle','labrador','pomeranian','pug', 'shih-tzu'].indexOf($scope.breed) !== -1) {
            sessionStorage.setItem('petBreed', $scope.breed);
            updateHeader.petType = $scope.breed;
        }
    } else {
        updateHeader.petType = 'default';
    }

    var trustboxRef = document.getElementById('trustbox');
    var trustboxWdgt =  document.getElementById('trustbox-widget');
    if((trustboxWdgt || trustboxRef) && window.Trustpilot){
        window.Trustpilot.loadFromElement(trustboxRef);
        window.Trustpilot.loadFromElement(trustboxWdgt);
    }

            //straight throuh validation logic
            var params = {}, encryptedParams = getUrlParameter('encryptedParams'), parisRef = getUrlParameter('RefNo');
            $scope.straightThroughValidation = encryptedParams !== '' ? true : false;

        angular.element(document).ready(function () {
            if (encryptedParams !== '') {
                params = {
                    encryptedParams: encryptedParams,
                    parisRef: parisRef
                };
                loadingInterceptor.incrementRequests();
                setTimeout(function () {
                    getQuoteDetails(params);
                    loadingInterceptor.decrementRequests();
                }, 2000);
            }
        });

    angular.element(document).ready(function () {
        if (encryptedParams !== '') {
            params.encryptedParams = encryptedParams;
            loadingInterceptor.incrementRequests();
            getQuoteDetails(params);
            loadingInterceptor.decrementRequests();
        }
    });

    function getUrlParameter(name) {
        name = name.replace(/[\[]/, '\\[').replace(/[\]]/, '\\]');
        var regex = new RegExp('[\\?&]' + name + '=([^&#]*)');
        var results = regex.exec(location.search);
        return results === null ? '' : decodeURIComponent(results[1]).replace(/ /g,'+');
    }

    $scope.submit = function() {
        console.log('submit');
        var params;
        if($rootScope.altRetrieveEcover){
            params = {
                email: $scope.retrieveQuote.email,
                petName: $scope.retrieveQuote.pet,
                postCode: $scope.retrieveQuote.postCode,
            };
        }
        else{
            params = {
                quoteRef: $scope.retrieveQuote.quoteRef,
                postCode: $scope.retrieveQuote.postCode,
                dob: $scope.retrieveQuote.dob
            };
        }

        if (campaign) {
            params.campaign = campaign;
        }
        getQuoteDetails(params);
    };

    //retrieve Quote details
    function getQuoteDetails(params){

        var application;
        var env = window.location.hostname;

        loadingInterceptor.incrementRequests();
        formService.getQuote(params).then(
            function(response) {
                formService.setApplicationId(response.data.uri.split('/').pop());
                formService.setQuoteExpiry(response.data.isQuoteExpired);
                return formService.getApplication();
            }
        ).then(
            function(response) {

                application = response.data;
                $scope.pet= response.data.application.pets[0];
                $scope.petDetails = response.data.application.pets[0].details;
                $scope.searchConstraints = $scope.$parent.schema.types.dog.details.breedOne.constraints;
                $scope.isSpecialBreed = false;
                angular.forEach( $scope.searchConstraints, function (value, key) {
                    $scope.breedType = $scope.petDetails.type;
                    $scope.breedList = value.values;
                    $scope.modelValue = isSpecialListBreed();
                    if (value && $scope.modelValue) {
                        $scope.index = $scope.breedList.indexOf($scope.modelValue);
                        $scope.isSpecialBreed = true;
                    }
                });


        
                // reset any existing campaign info
                $scope.$parent.campaign = '';
                $scope.$parent.brav = '';
                sessionStorage.removeItem('campaign');
                sessionStorage.removeItem('brav');
                sessionStorage.removeItem('eQuote');
                sessionStorage.removeItem('eQuoteCn');
                sessionStorage.removeItem('eCoverNote');
                sessionStorage.removeItem('eCoverJourney');

                if(application.officeUseOnly.params.channel === "sa-ecovernote-orc"){   
                    if ($scope.isSpecialBreed) {
                        triggerSpecialListBreedPopup();
                    } else {
                        // set the ecover flag
                        sessionStorage.setItem('eCoverNote', 'true');
                        if (!application.runningTotals) {
                            sessionStorage.setItem('currentRefreshState', 'details-ec');
                        } else {
                            sessionStorage.setItem('currentRefreshState', 'quote-ec');
                        }
                        // set recognised or returning
                        if (application.officeUseOnly.params.recognized === 'Y') {
                            sessionStorage.setItem('eCoverJourney', 'recognised');
                        } else {
                            sessionStorage.setItem('eCoverJourney', 'retrieveQB');
                        }
                    }
                }

                if(application.officeUseOnly.params.channel === "sa-equote-orc"){
                    if ($scope.isSpecialBreed) {
                        triggerSpecialListBreedPopup();
                    } else {
                        sessionStorage.setItem('eQuote', 'true');
                        sessionStorage.setItem('currentRefreshState', 'step-4e');
                    }

                    if(application.officeUseOnly.params.quoAffinity){
                        sessionStorage.setItem('campaign',application.officeUseOnly.params.quoAffinity);
                    }

                    if(application.officeUseOnly.params.convFrm === "C"){
                        sessionStorage.setItem('eQuoteCn', 'true');
                    }
                    //var appState = getApplicationState(application.application);
                }

                if (application.officeUseOnly && application.officeUseOnly.params) {
                    if ($scope.isSpecialBreed) {
                        triggerSpecialListBreedPopup();
                    } else {
                        if(application.officeUseOnly.params.quoAffinity){
                            sessionStorage.setItem('campaign',application.officeUseOnly.params.quoAffinity);
                        }
                        else{
                            $scope.$parent.campaign = application.officeUseOnly.params.campaign;
                            sessionStorage.setItem('campaign',$scope.$parent.campaign);

                        }

                        $scope.$parent.brav = application.officeUseOnly.params.brav;
                        sessionStorage.setItem('brav',$scope.$parent.brav);
                    }
                }


                if(sessionStorage.getItem('eCoverNote')){ 
                    sessionStorage.setItem('retrieveQuote', 'true');
                    var loc = 'details';
                    var step3State = 'quote';
                    var i=0;
                    if (sessionStorage.getItem('currentRefreshState') === 'quote-ec' ) {
                        step3State = 'quote';
                        while (i < application.application.pets.length -1 && application.application.pets[i].chosenCover && application.application.pets[i].chosenCover.productId && application.application.pets[i].chosenCover.productLine) {
                            i++;
                        }
                        if(!application.application.pets[i].chosenCover) {
                            step3State = 'quote';
                        } else {
                            step3State = 'quote';
                        } 
                        loc = 'quote/' + i + '/' + step3State;

                    }
                    if (env.search('petplan.co.uk') !== -1 || env.search('azuk.cloud') !== -1) {
                        window.location.href='/ecover/' + loc;  
                    }
                    else {
                        window.location.href='/content/ah_small-animal/ecover/index.html/ecover/' + loc;
                    }
                }
                
                /*  formService.getRunningTotals().then(
                    //THIS ONE
                    /*function(response) {
                        if(response.data.resetBreed === "Y"){

                            sessionStorage.setItem('reQuoteModal', 'true');
                        }
                        if( response.data.resetBreed === "N"){
                            sessionStorage.setItem('reQuoteModal', 'false');
                        }
                    }
                );*/

                if (moment(application.application.cover.startDate).isBefore( moment().format('YYYY-MM-DD') )) {
                    pastCoverStartDate = true;
                    var coverStartDate = {
                        startDate: moment().format('YYYY-MM-DD')
                    };
                    return formService.postCover(coverStartDate);
                } else {
                    var deferred = $q.defer();
                    deferred.resolve();
                    return deferred.promise;
                }
                
            }
        ).then(
            function() {
                if (pastCoverStartDate) {
                    return formService.getRunningTotals();
                } else {
                    var deferred = $q.defer();
                    deferred.resolve();
                    return deferred.promise;
                }
            } 
        ).then(
            function(response) {

                return formService.getApplication();
            }
        ).then(
            function(response) {
                if (!$scope.isSpecialBreed) {

                    application = response.data;
                    populateFormData(application);
                    loadingInterceptor.decrementRequests();

                    var appState = getApplicationState(application.application);
                    sessionService.start();

                    // Check whether Retrive Quote is Expired
                    if (sessionStorage.getItem('isQuoteExpired') === 'Y') {
                        $state.go('retrieve-expired', { forward: true });
                    } else if (sessionStorage.getItem('eQuote')) {
                        if (application.application.pets.length >= 2) {
                            sessionStorage.setItem('pet', 'multipet');
                        } else {
                            sessionStorage.setItem('pet', application.application.pets[0].type);
                        }

                        // Quick fix remove before live//
                        env = window.location.hostname;
                        if (env.search('petplan.co.uk') !== -1 || env.search('azuk.cloud') !== -1) {
                            window.location.href = '/equote/step-4';
                        } else {
                            window.location.href = '/content/ah_small-animal/equote/index.html/step-4';
                        }
                        // Quick fix remove before live//
                    }
                    else {
                        $state.go(appState.step, { id: appState.petId, selectState: appState.position, petId: appState.petId, position: appState.position, retrieve: appState.retrieve });
                    }
                }
                // fix for STV to hide fetching modal once quote loaded
                if ($scope.straightThroughValidation === true) {
                    loadingInterceptor.decrementRequests();
                }
            }
        ).catch(
            function(error) {
                if (encryptedParams) {
                    //if decryption fails redirect to normal retrieval rather than going to error screen
                    encryptedParams = '';
                    $scope.straightThroughValidation = false;
                    errorHandler.reportErrors(error, 'decryptionFailed', 'retrieve-quote');
                }
                else {
                    errorHandler.reportErrors(error, 'redirect', 'retrieve');
                }
            }
        );
    }

    function isSpecialListBreed (){
        if ($scope.breedType && $scope.breedList) {
            if ($scope.breedType === 'Pedigree') {
                if ($scope.breedList.indexOf($scope.petDetails.pedigreeBreed) !== -1) {
                    sessionStorage.setItem('isEquote', true);
                    return $scope.petDetails.pedigreeBreed;
                }
            }
            else {
                if ($scope.breedList.indexOf($scope.petDetails.breedOne) !== -1) {
                    return $scope.petDetails.breedOne;
                }
                else if ($scope.breedList.indexOf($scope.petDetails.breedTwo) !== -1) {
                    return $scope.petDetails.breedTwo;
                }
            }
        }
    }

    function triggerSpecialListBreedPopup (){
        loadingInterceptor.decrementRequests();
         // need timeout as delay in getting value
         $timeout(function () {
             $rootScope.$broadcast('SPECIAL.BREED.INDEX');
             scrollToPoint.scrollTo('specialistBreedModal', 20, 'id');
             // sessionStorage.setItem('eQuote', 'false');
         }, 200);
    }
    // get a new quote from expired quote
    $scope.retrieveExpiredQuoteDetails = function() {
        formService.postnewQuoteFromAnOldQuote().then(
            function(response) {
                sessionStorage.clear();
                formService.setApplicationId(response.data.uri.split('/').pop());
                return formService.getApplication();
            }).then(function(response){
                // identi offer post 28 days recheck campaign code
                if(response.data.officeUseOnly && (response.data.officeUseOnly.params.campaign === 'LAPIDALT' || response.data.officeUseOnly.params.campaign === 'IDTALERT' )) {
                    $scope.$parent.idt = 'true';
                } else {
                    $scope.$parent.idt = 'false';
                }
                $state.go('step-3', { forward: true });
            }).catch(
                function(error) {
                    errorHandler.reportErrors(error, 'redirect', 'retrieve');
            });
        };

    $scope.startNew = function() {
        $state.go('step-1', {forward: true});
    };

    function populateFormData(data) {
        sessionStorage.setItem('retrieveQuote', 'true');
        $rootScope.retrieveQuote = true;
        
        $scope.formData.pets = data.application.pets;
        $scope.formData.aboutYou = data.application.aboutYou;
        $scope.formData.cover = data.application.cover;
        $scope.formData.charitableDonation = data.application.charitableDonation;
        //THIS ONE
        /*formService.getRunningTotals().then(
            function(response) {
                if(response.data.resetBreed === "Y"){

                    sessionStorage.setItem('reQuoteModal', 'true');
                }
                if( response.data.resetBreed === "N"){
                    sessionStorage.setItem('reQuoteModal', 'false');
                }
            }
        );*/


    }

    function getApplicationState(application) {
        

        var step = 'step-3-select',
            petId,
            position,
            index,
            allPetsHaveCover = true;

        if (step === 'step-3-select') {
            position = 'quote';
            index = 0;
            petId = index;
            while(index < application.pets.length ) {
                if (application.pets[index].chosenCover && application.pets[index].chosenCover.productLine && application.pets[index].chosenCover.productId)  {
                    index = index + 1;
                } else {
                    allPetsHaveCover = false;
                    if (application.pets[index].chosenCover && !application.pets[index].chosenCover.productId) {
                        position = 'quote';
                    } else {
                        position = 'quote';
                        allPetsHaveCover = false;
                    }
                    petId = index;
                    break;

                }

            }
        }

        // go to step4 for multipet if cover has been chosen
        if (allPetsHaveCover && application.pets.length > 1) {
            step = 'step-4';
        }
        
        return {
            step: step,
            petId: petId,
            position: position,
            retrieve: true
        };
    }

    if (typeof window.rTapNotifyDOMChange === "function") {
        window.rTapNotifyDOMChange(document.getElementById('skipnav'));
    }

    $scope.rightSeeker = function() {
        document.getElementById('slide-track').scrollLeft += 150;
    };
    $scope.leftSeeker = function() {
        document.getElementById('slide-track').scrollLeft -= 150;
    };

}]);
})(window, window.angular);
